import { CheckOutlined } from '@ant-design/icons'
import { addUserByRole, addUserFieldsData, fetchStudentsClassList, fetchStudentsWRTCourseType, fetchAutocompleteCoursesList } from 'actions/userManagementV2'
import { Checkbox, Col, Input, Modal, Row, Select } from 'antd'
import { Button } from 'components/Button'
import { Heading } from 'components/Typography'
import { IMG_URL } from "env.json"
import { EditImage, ImageComponent } from 'pages/profile/subComponents'
import React, { useEffect, useRef, useState } from 'react'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import { connect } from 'react-redux'
import { Notification, attendanceCodeError } from 'services'
const defaultImg = require("../../../Assets/Icon awesome-user-alt.svg").default

const { Option } = Select;

const AddUser = ({ open, onCancel, addUserByRole, addUserFieldsData, addUserFields, classList, user, fetchStudentsWRTCourseType, autocompleteCoursesData, fetchAutocompleteCoursesList, getDashboard, userObj }) => {

        const isStaffSection = userObj?.userRole === 'Teachers' || userObj?.userRole === 'Data Operators' || userObj?.userRole === 'Operations';
        const roles = window.location.pathname === "/user/staff" ? ['Teacher', 'Data Operator', 'Operations'] : ['Student', 'Teacher', 'Data Operator', 'Operations'];

        const [buttonLoader, toggleButtonLoader] = useState(false);
        const [isAdminSelected, setIsAdminSelected] = useState(false);
        const [isPlannerSelected, setIsPlannerSelected] = useState(false);
        const [editProfileModal, setEditProfileModal] = useState(false);
        const [deleteConfirmation, setdeleteConfirmation] = useState(false);


        const fillTheDetails = addUserFields?.role == '' || addUserFields?.role == undefined || addUserFields?.name?.trim() == '' || addUserFields?.phone == '' || addUserFields?.phone == undefined || addUserFields?.phone == null;
        const inputProfilePic = useRef();

        const codeLabel = addUserFields?.role === 'Student' ? 'Student code' : 'Employee code';
        // the device identifies a user by their code, so enrolling without one is not possible
        const codeMissingForBiometric = !!addUserFields?.registerBiometric && !addUserFields?.attendanceEmpCode?.trim();
        const codeFormatError = attendanceCodeError(addUserFields?.attendanceEmpCode);

        const resetFields = () => {
                // the courses screen only adds students, so default the role there
                addUserFieldsData('role', window.location.pathname === "/user-management/courses" ? 'Student' : '');
                addUserFieldsData('file', '');
                addUserFieldsData('phone', null);
                addUserFieldsData('email', '');
                addUserFieldsData('course', null);
                addUserFieldsData('name', '');
                addUserFieldsData('privilage', []);
                addUserFieldsData('attendanceEmpCode', '');
                addUserFieldsData('registerBiometric', false);
        };

        const callback = (res) => {
                if(res !== undefined){
                        // The user is created either way; enrolment is reported separately so a
                        // device failure is visible rather than silently swallowed.
                        if (res?.biometric && res.biometric.enrolled === false) {
                                Notification.error('Error', res.biometric.message);
                        }
                        resetFields();
                        onCancel();
                }
                toggleButtonLoader(false);
        }

        useEffect(() => {
                resetFields();
        }, []);

        useEffect(() => {
                if (!autocompleteCoursesData?.length || addUserFields?.role == 'Student') {
                        fetchAutocompleteCoursesList({ emptySearch: true, names: true, fromCourse: true }, () => { })
                }
        }, [addUserFields?.role]);

        // if Admin is selected from the privilege list then, Planner and Institute support checkboxes get ticked and disables. 
        // useEffect(() => {
        //         if (addUserFields?.privilage?.includes("Admin")) {
        //                 setIsAdminSelected(true);
        //                 if (addUserFields?.privilage?.indexOf("Planner") > -1) {
        //                         addUserFields?.privilage?.splice(addUserFields?.privilage?.indexOf("Planner"), 1);
        //                 }
        //                 if (addUserFields?.privilage?.indexOf("InstituteSupport") > -1) {
        //                         addUserFields?.privilage?.splice(addUserFields?.privilage?.indexOf("InstituteSupport"), 1);
        //                 }
        //                 if (addUserFields?.privilage?.indexOf("AttendanceMarker") > -1) {
        //                         addUserFields?.privilage?.splice(addUserFields?.privilage?.indexOf("AttendanceMarker"), 1);
        //                 }
        //         } else {
        //                 setIsAdminSelected(false);
        //         }
        // }, [addUserFields?.privilage]);
        useEffect(() => {
    let privileges = [...(addUserFields?.privilage || [])];

    const isAdmin = privileges.includes("Admin");
    const isPlanner = privileges.includes("Planner");

    setIsAdminSelected(isAdmin);
    setIsPlannerSelected(isPlanner);

    // Admin → remove conflicting privileges
    if (isAdmin) {
        privileges = privileges.filter(
            item =>
                item !== "Planner" &&
                item !== "InstituteSupport" &&
                item !== "AttendanceMarker"
        );
    }

    // Planner → remove AttendanceMarker
    if (isPlanner) {
        privileges = privileges.filter(
            item => item !== "AttendanceMarker"
        );
    }

    if (
        JSON.stringify(privileges) !==
        JSON.stringify(addUserFields?.privilage)
    ) {
        addUserFieldsData("privilage", privileges);
    }
}, [addUserFields?.privilage]);

        const onChange = (checkedValues) => {
                addUserFieldsData('privilage', checkedValues);
        }



        const handleAddClick = () => {
                if (fillTheDetails) {
                        Notification.error('Error', 'Please fill all the mandatory details');
                } else if (
                        !isValidPhoneNumber(addUserFields?.phone || '')
                ) {
                        Notification.error('Please enter a valid mobile number');
                } else if (codeMissingForBiometric) {
                        Notification.error('Error', `Please enter the ${codeLabel.toLowerCase()} to register on the biometric device`);
                } else if (codeFormatError) {
                        Notification.error('Error', codeFormatError);
                } else {
                        toggleButtonLoader(true);
                        addUserByRole(callback, null);
                        fetchStudentsWRTCourseType(null, callback)
                        let params = {
                                userType: 'Student',
                                status: 'Approved',
                                limit: 10
                        };
                        getDashboard(params, () => { })



                };
        };

        const onDeleteConfirm = (callback, successCallback) => {
                callback()
                setImageRemove(false)
                successCallback()
        }

        const handleProfileModalOk = () => {
                setEditProfileModal(false);
                setImageRemove(true)
                inputProfilePic?.current?.click();
        };

        const [imageRemove, setImageRemove] = useState(false)

        return (
                <div>
                        <Modal
                                centered
                                closable
                                open={open}
                                footer={null}
                                className='modal-round-corner'
                                onCancel={onCancel}
                        >
                                <div className='p-20'>
                                        <center>
                                                <Heading>Add a user</Heading>
                                        </center>
                                        <center className='' style={{ marginTop: -20, marginBottom: -25 }}>

                                                <ImageComponent
							userProfileDetails={{ name: addUserFields?.name }}
                                                        src={addUserFields?.photo ? addUserFields?.photo : 'default.png'}
                                                        onChange={() => { }}
                                                        handleEditModal={setEditProfileModal}
                                                        ref={inputProfilePic}
                                                        imageRemove={imageRemove}
                                                        defaultImg={defaultImg}
                                                        setfileInputValue={(file) => { addUserFieldsData('file', file) || 'default.png' }}
                                                />
                                        </center>

                                        <div style={{ float: 'left', fontWeight: 500, }}>Role <span style={{ color: 'red' }}>*</span></div>
                                        {window.location.pathname === "/user-management/courses" ? (
                                                <div className="ant-input ant-input-disabled" style={{ display: 'flex', alignItems: 'center', backgroundColor: '#fafafa', color: '#636363', cursor: 'not-allowed' }}>Student</div>
                                        ) : (
                                                <Select value={addUserFields?.role || undefined} onChange={(value) => addUserFieldsData('role', value)} style={{ width: '100%' }} placeholder='Select role'>
                                                        {roles?.map((role, index) => (
                                                                <Option value={role} key={index}>{role}</Option>
                                                        ))}
                                                </Select>
                                        )}

                                        <div style={{ float: 'left', fontWeight: 500, marginTop: 12 }}>Name <span style={{ color: 'red' }}>*</span></div>
                                        <Input style={{ width: '100%' }} value={addUserFields?.name} placeholder='Enter name' onChange={(e) => addUserFieldsData('name', e.target.value)} />

                                        <div style={{ float: 'left', fontWeight: 500, marginTop: 12 }}>Mobile number <span style={{ color: 'red' }}>*</span></div>
                                        <PhoneInput value={addUserFields?.phone} onChange={(e) => addUserFieldsData('phone', e)} className="PhoneInputBa" defaultCountry="IN" placeholder='Enter mobile number' height={"40px"} style={{ width: '100%' }} maxLength={(addUserFields?.phone?.startsWith('+91') || addUserFields?.phone?.startsWith('91')) && addUserFields?.phone?.length == 13 ? 11 : ""} />

                                        <div style={{ float: 'left', fontWeight: 500, marginTop: 12 }}>Email ID</div>
                                        <Input value={addUserFields?.email} style={{ width: '100%' }} onChange={(e) => addUserFieldsData('email', e.target.value)} />

                                        <div style={{ clear: 'both', paddingTop: 20 }}>
                                                <Checkbox
                                                        checked={!!addUserFields?.registerBiometric}
                                                        onChange={(e) => addUserFieldsData('registerBiometric', e.target.checked)}
                                                >
                                                        Register on biometric device
                                                </Checkbox>
                                        </div>

                                        <div style={{ float: 'left', fontWeight: 500, marginTop: 20 }}>
                                                {codeLabel} {addUserFields?.registerBiometric ? <span style={{ color: 'red' }}>*</span> : null}
                                        </div>
                                        <Input
                                                value={addUserFields?.attendanceEmpCode}
                                                style={{ width: '100%' }}
                                                maxLength={8}
                                                placeholder={`Enter ${codeLabel.toLowerCase()} e.g. 2026091`}
                                                onChange={(e) => addUserFieldsData('attendanceEmpCode', e.target.value)}
                                        />
                                        {codeMissingForBiometric ?
                                                <div style={{ color: '#FF414D', fontSize: 12, marginTop: 4 }}>
                                                        {codeLabel} is required to register on the biometric device
                                                </div>
                                                : codeFormatError ?
                                                        <div style={{ color: '#FF414D', fontSize: 12, marginTop: 4 }}>
                                                                {codeFormatError}
                                                        </div>
                                                        : null}
                                        {addUserFields?.role == 'Student' ?
                                                <>
                                                        <div className='m-t-12' style={{ fontWeight: 500 }}>Course</div>
                                                        <Select onChange={(val, obj) => {
                                                                const course = autocompleteCoursesData[obj.key - 1];
                                                                if (course) {
                                                                        addUserFieldsData('course', course.itemId);
                                                                        addUserFieldsData('courseType', course.type || '');
                                                                }
                                                        }}
                                                                placeholder='Select a course'
                                                                style={{ width: '100%' }}
                                                        >
                                                                {autocompleteCoursesData?.map((item) => {
                                                                        return <Option key={item?.id} value={item?.id}>{item?.name}</Option>
                                                                })}
                                                        </Select>
                                                </>
                                                :
                                                <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                        <Checkbox.Group
                                                                style={{ width: "100%", fontFamily: "Roboto" }}
                                                                onChange={onChange}
                                                                value={addUserFields?.privilage}
                                                        >
                                                                <Row>
                                                                        <Col style={{ marginBottom: "20px" }} span={8}>
                                                                                <Checkbox disabled={user?.privilage?.includes("Admin") && !user?.privilage?.includes("SuperAdmin") ? true : false}
                                                                                        value="Admin"
                                                                                >
                                                                                        Admin
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox checked={isAdminSelected} disabled={isAdminSelected} value="Planner">
                                                                                        Planner
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox
                                                                                        disabled={false}
                                                                                        value="FeeManager"
                                                                                >
                                                                                        Fee manager
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox
                                                                                        checked={isAdminSelected}
                                                                                        disabled={isAdminSelected}
                                                                                        value="InstituteSupport"
                                                                                >
                                                                                        Institute support
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col
                                                                                style={{ display: "block" }}
                                                                                span={8}
                                                                        >
                                                                                <Checkbox
                                                                                        checked={isAdminSelected}
                                                                                        disabled={isAdminSelected || isPlannerSelected}
                                                                                        value="AttendanceMarker"
                                                                                >
                                                                                        Attendance marker
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox
                                                                                        value="LeaveManager"
                                                                                        disabled={false}
                                                                                >
                                                                                        Leave Manager
                                                                                </Checkbox>
                                                                        </Col>
                                                                        <Col span={8}>
                                                                                <Checkbox
                                                                                        value="Marketing"
                                                                                >
                                                                                        Marketing
                                                                                </Checkbox>
                                                                        </Col>
                                                                </Row>
                                                        </Checkbox.Group>
                                                </div>
                                        }

                                        <center className='m-t-20'>
                                                <Button disabled={fillTheDetails || codeMissingForBiometric || !!codeFormatError} loading={buttonLoader} type='primary' onClick={() => handleAddClick()}>ADD</Button>
                                        </center>
                                </div>
                        </Modal>
                        {editProfileModal &&
                                <EditImage
                                        imageUrl={addUserFields?.file?.name || 'default.png'}
                                        onEditCancel={() => setEditProfileModal(false)}
                                        editModalVisible={editProfileModal}
                                        handleEditOk={handleProfileModalOk}
                                        deleteConfirm={() => {
                                                setdeleteConfirmation(true), setEditProfileModal(true);
                                        }}
                                        deleteModalVisible={deleteConfirmation}
                                        onDeleteCancel={() => setdeleteConfirmation(false)}
                                        setEditProfileModal={setEditProfileModal}
                                        setdeleteConfirmation={setdeleteConfirmation}
                                        addUserFieldsData={addUserFieldsData}
                                        setImageRemove={setImageRemove}
                                        onDeleteConfirm={(callback, successCallback) => onDeleteConfirm(callback, successCallback)}
                                />
                        }
                </div>
        )
}

const mapStateToProps = (state) => {
        const { user } = state.session;
        const { classList, addUserFields, autocompleteCoursesData, userObj } = state.userManagementV2;
        return { classList, addUserFields, autocompleteCoursesData, userObj }
};

const mapDispatchToProps = (dispatch) => ({
        addUserFieldsData: (key, val) => dispatch(addUserFieldsData(key, val)),
        fetchStudentsWRTCourseType: (params, callback) => dispatch(fetchStudentsWRTCourseType(params, callback)),
        addUserByRole: (callback, successCallBack) => dispatch(addUserByRole(callback, successCallBack)),
        fetchStudentsClassList: (params, callBack) => dispatch(fetchStudentsClassList(params, callBack)),
        fetchAutocompleteCoursesList: (params, callBack) => dispatch(fetchAutocompleteCoursesList(params, callBack)),
});



export default connect(mapStateToProps, mapDispatchToProps)(AddUser)